import { StyledIcon } from "./IconStyles";

const Icon = ({
  src,
  alt,
  iconDimension,
  styleProps,
  onClick,
}: {
  src: string;
  alt: string;
  iconDimension?: number;
  styleProps?: object;
  onClick?: () => void;
}) => {
  return (
    <StyledIcon
      src={src}
      alt={alt}
      iconDimension={iconDimension}
      style={styleProps}
      onClick={onClick}
    />
  );
};

export default Icon;
